<mat-card class="cardWithShadow">
    <mat-card-header>
        <div class="upload-buttons-container">
            <mat-card-title>{{ 'FILES' | translate }}</mat-card-title>
            <div class="buttons-container">
                <button mat-raised-button color="primary" class="bigger-button" (click)="syncS3FilesWithScan(orderId)">
                    {{ 'MVF_SYNC' | translate }}
                </button>
                <button mat-raised-button color="primary" class="bigger-button" [disabled]="selectedFiles?.length === 0"
                    (click)="downloadSelectedFilesAsZip()">
                    {{ 'MVF_DOWNLOAD_SELECTED' | translate }} ({{ selectedFiles?.length }})
                </button>
                <p-fileUpload #fileUpload [multiple]="true" mode="basic" chooseLabel="{{ 'UPLOAD_FILE' | translate }}"
                    customUpload="true" [auto]="false" accept=".stl, .obj, .png, .jpeg, .jpg, .pdf"
                    (onUpload)="uploadFile()" (onSelect)="onFileSelect($event)"
                    [style]="{ 'background-color': '#5d87ff', 'color': 'white', 'border-radius': '5px' }">
                </p-fileUpload>
            </div>
        </div>
    </mat-card-header>

    <mat-card-content>
        <mat-progress-bar *ngIf="loading" mode="indeterminate" style="margin-top: 10px;"></mat-progress-bar>
        <p-table [value]="files" [(selection)]="selectedFiles" sortField="categoryPriority" sortMode="single"
            [scrollable]="true" scrollHeight="470px" rowGroupMode="subheader" groupRowsBy="categoryPriority"
            [tableStyle]="{'min-width': '60rem'}">
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <p-tableHeaderCheckbox [disabled]="!canShowSelectAll()">
                        </p-tableHeaderCheckbox>
                        <span style="margin-left: 5px;">{{ 'MVF_SELECT_ALL' | translate }}</span>
                    </th>
                    <th>{{ 'MVF_FORMAT' | translate }}</th>
                    <th>{{ 'MVF_NAME' | translate }}</th>
                    <th>{{ 'MVF_ACTIONS' | translate }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="groupheader" let-file>
                <tr pRowGroupHeader>
                    <td colspan="5">
                        <div style="display: flex; gap: 7px; align-items: center;">
                            <img *ngIf="file.category == 'Scans'" src="/assets/images/scans_icon.png"
                                class="icon-45 d-flex">
                            <img *ngIf="file.category == 'Designs'" src="/assets/images/designs_icon2.png"
                                class="icon-45 d-flex">
                            <i-tabler *ngIf="file.category == 'PDFs'" name="file-type-pdf"
                                class="icon-20 d-flex"></i-tabler>
                            <i-tabler *ngIf="file.category == 'Images'" name="photo-scan"
                                class="icon-20 d-flex"></i-tabler>
                            <span><strong>{{ 'MVF_CAT_' + (file.category | uppercase) | translate }}</strong></span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-file let-rowIndex="rowIndex">
                <tr [pSelectableRow]="file">
                    <td>
                        <p-tableCheckbox *ngIf="file.paid || file.type === 'pdf' || file.type === 'jpeg'"
                            [value]="file"></p-tableCheckbox>
                    </td>
                    <td>
                        {{file.type}}
                    </td>
                    <td>
                        {{file.name}}
                        <br>
                        <small *ngIf="file.paidBy" class="text-success">{{ 'MVF_REQUESTED_BY' | translate }}
                            <b>{{file.paidBy}}</b> {{ 'MVF_AT' | translate }} <b>{{ file.payDate | date
                                }}</b></small>
                        <br>
                        <small *ngIf="file.paymentChargedTo" class="text-primary">{{ 'CHARGED_TO' |
                            translate}}
                            <b>{{file.paymentChargedTo}}</b></small>
                    </td>
                    <td>
                        <div style="display: flex; gap: 10px;">
                            <a *ngIf="!file.paid && (file.type == 'stl' || file.type == 'obj' || (file.type == 'ply' && file.name.includes('processed')))"
                                class="icon" matTooltip="{{ 'MVF_PAY_FILE' | translate }}"
                                (click)="getAccessToFiles(file.path)">
                                <i-tabler name="currency-dollar" class="icon-25"></i-tabler>
                            </a>
                            <a *ngIf="file.type == 'stl' || file.type == 'obj' || (file.type == 'ply' && file.name.includes('processed'))"
                                class="icon" matTooltip="{{ 'MVF_EDIT_FILE' | translate }}"
                                (click)="redirectTo3DViewer(orderId, file.name)">
                                <i-tabler name="pencil-star" class="icon-25"></i-tabler>
                            </a>
                            <a (click)="downloadFile(file.path)" class="icon"
                                matTooltip="{{ 'MVF_DOWNLOAD_FILE' | translate }}"
                                *ngIf="file.paid || file.type == 'pdf' || file.type == 'jpeg'">
                                <i-tabler name="cloud-down" class="icon-25"></i-tabler>
                            </a>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </mat-card-content>
</mat-card>

<p-dialog header="Files Classificator" [(visible)]="showFileClassificationModal" [modal]="true" [closable]="false"
    [draggable]="false" [resizable]="false" [baseZIndex]="10000">
    <app-three-d-file-classificator [filesToClassify]="filesToClassify" (closeModalWhenSubmit)="handleCloseModal()"
        (closeModalWhenCancel)="handleCloseModalWhenCancel()"
        (formDataReady)="handleFormDataReady($event)"></app-three-d-file-classificator>
</p-dialog>